exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ciu-main-menu {\r\n  margin-left: 20%;\r\n  text-align: center;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/header/main-menu/main-menu.component.css
// module id = ../../../../../src/app/header/main-menu/main-menu.component.css
// module chunks = main